import { useEffect, useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const useFingerprint = () => {
	const [fingerprint, setFingerpring] = useState<string>("");

	useEffect(() => {
		const setFp = async () => {
			const fp = await FingerprintJS.load();

			const { visitorId } = await fp.get();

			setFingerpring(visitorId);
		};

		setFp();
	}, []);

	return { fingerprint };
};
